// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"8c4f9173","142":"70651465","199":"743ad7af","584":"99b4bf22","731":"71744ead","852":"5b05073f"}[chunkId] + ".chunk.js";
};